<template>
  <router-view />
  <PiniaColadaDevtools v-if="isDev" />
</template>

<script lang="ts">
import { PiniaColadaDevtools } from '@pinia/colada-devtools'

export default {
  components: {
    PiniaColadaDevtools
  },
  computed: {
    isDev() {
      return import.meta.env.MODE === 'development'
    }
  }
}
</script>

<style lang="scss">
// platform-wide css classes
.hd-badge {
  display: inline-block;
  padding: 2px 6px;
  font-size: 0.9em;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
  color: white;
}
.hd-0-bed-bg {
  background-color: $blue;
}
.hd-1-bed-bg {
  background-color: $green;
}
.hd-2-bed-bg {
  background-color: $amber;
}
.hd-3-bed-bg {
  background-color: $deep-orange;
}
.hd-4-bed-bg {
  background-color: $deep-purple;
}
.hd-5-bed-bg {
  background-color: $cyan;
}
.hd-6-bed-bg {
  background-color: $teal;
}
.hd-7-bed-bg {
  background-color: $purple;
}
.hd-8-bed-bg {
  background-color: $grey;
}
.q-table__sort-icon--left,
.q-table__sort-icon--center {
  margin-left: 0px !important;
}
@media print {
  .clickable-table-cell {
    text-decoration: none !important;
  }

  .q-table {
    border-left: solid $grey-4 1px !important;
    border-right: solid $grey-4 1px !important;
    border-bottom: solid $grey-4 1px !important;
  }
}
.clickable-table-cell {
  text-decoration: underline;
  text-decoration-color: $grey-6;
  cursor: pointer;
}
.clickable-table-cell:hover {
  text-decoration-color: $grey-9;
}
.body--dark {
  .clickable-table-cell:hover {
    text-decoration-color: $grey-1;
  }
  .subject .clickable-table-cell:hover {
    text-decoration-color: $primary;
  }
  .subject .clickable-table-cell {
    text-decoration-color: #484ab1;
  }
  // This is the default background color for q-selects
  .default-bg {
    background-color: #ffffff12;
  }
}
.subject .clickable-table-cell {
  text-decoration-color: $deep-purple-3;
}
.subject .clickable-table-cell:hover {
  text-decoration-color: $primary;
}
.default-bg {
  background-color: #0000000d;
}

.fancy-feature-box {
  border-radius: 8px;
  border: 1px solid rgba(100, 100, 255, 0.3);
  background: rgba(100, 100, 255, 0.03);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      rgba(66, 99, 255, 0.1),
      rgba(66, 99, 255, 0),
      rgba(66, 99, 255, 0.1)
    );
    z-index: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &.active {
    border-color: rgba(100, 100, 255, 0.6);
    box-shadow: 0 0 15px rgba(100, 100, 255, 0.2);
  }
}

.dark .fancy-feature-box {
  border-color: rgba(100, 100, 255, 0.4);
  background: rgba(100, 100, 255, 0.05);

  &.active {
    border-color: rgba(100, 100, 255, 0.8);
    box-shadow: 0 0 20px rgba(100, 100, 255, 0.3);
  }
}
</style>
